/* Auto-generated — run: npm run build:southlands-supplemental */

import type { ProgressCarouselItem } from '../components/ProgressStageCarousel';

export type SouthlandsSupplementalStage = {
  date: string;
  title: string;
  items: ProgressCarouselItem[];
};

export const SOUTHLANDS_SUPPLEMENTAL_STAGES: SouthlandsSupplementalStage[] = [
  {
    "date": "June 2026",
    "title": "Roof Progress and Internal Fit-Out",
    "items": [
      {
        "src": "/progress/southlands/18-roof-progress-and-internal-fit-out/000.jpg",
        "type": "image",
        "alt": "Roof Progress and Internal Fit-Out, photo 1 of 13"
      },
      {
        "src": "/progress/southlands/18-roof-progress-and-internal-fit-out/001.jpg",
        "type": "image",
        "alt": "Roof Progress and Internal Fit-Out, photo 2 of 13"
      },
      {
        "src": "/progress/southlands/18-roof-progress-and-internal-fit-out/002.jpg",
        "type": "image",
        "alt": "Roof Progress and Internal Fit-Out, photo 3 of 13"
      },
      {
        "src": "/progress/southlands/18-roof-progress-and-internal-fit-out/003.jpg",
        "type": "image",
        "alt": "Roof Progress and Internal Fit-Out, photo 4 of 13"
      },
      {
        "src": "/progress/southlands/18-roof-progress-and-internal-fit-out/004.jpg",
        "type": "image",
        "alt": "Roof Progress and Internal Fit-Out, photo 5 of 13"
      },
      {
        "src": "/progress/southlands/18-roof-progress-and-internal-fit-out/005.jpg",
        "type": "image",
        "alt": "Roof Progress and Internal Fit-Out, photo 6 of 13"
      },
      {
        "src": "/progress/southlands/18-roof-progress-and-internal-fit-out/006.jpg",
        "type": "image",
        "alt": "Roof Progress and Internal Fit-Out, photo 7 of 13"
      },
      {
        "src": "/progress/southlands/18-roof-progress-and-internal-fit-out/007.jpg",
        "type": "image",
        "alt": "Roof Progress and Internal Fit-Out, photo 8 of 13"
      },
      {
        "src": "/progress/southlands/18-roof-progress-and-internal-fit-out/008.jpg",
        "type": "image",
        "alt": "Roof Progress and Internal Fit-Out, photo 9 of 13"
      },
      {
        "src": "/progress/southlands/18-roof-progress-and-internal-fit-out/009.jpg",
        "type": "image",
        "alt": "Roof Progress and Internal Fit-Out, photo 10 of 13"
      },
      {
        "src": "/progress/southlands/18-roof-progress-and-internal-fit-out/010.jpg",
        "type": "image",
        "alt": "Roof Progress and Internal Fit-Out, photo 11 of 13"
      },
      {
        "src": "/progress/southlands/18-roof-progress-and-internal-fit-out/011.jpg",
        "type": "image",
        "alt": "Roof Progress and Internal Fit-Out, photo 12 of 13"
      },
      {
        "src": "/progress/southlands/18-roof-progress-and-internal-fit-out/012.jpg",
        "type": "image",
        "alt": "Roof Progress and Internal Fit-Out, photo 13 of 13"
      }
    ]
  },
  {
    "date": "May 2026",
    "title": "Roof Trusses and Weather-Tight",
    "items": [
      {
        "src": "/progress/southlands/17-roof-trusses-and-weather-tight/000.jpg",
        "type": "image",
        "alt": "Roof Trusses and Weather-Tight, photo 1 of 26"
      },
      {
        "src": "/progress/southlands/17-roof-trusses-and-weather-tight/001.jpg",
        "type": "image",
        "alt": "Roof Trusses and Weather-Tight, photo 2 of 26"
      },
      {
        "src": "/progress/southlands/17-roof-trusses-and-weather-tight/002.jpg",
        "type": "image",
        "alt": "Roof Trusses and Weather-Tight, photo 3 of 26"
      },
      {
        "src": "/progress/southlands/17-roof-trusses-and-weather-tight/003.jpg",
        "type": "image",
        "alt": "Roof Trusses and Weather-Tight, photo 4 of 26"
      },
      {
        "src": "/progress/southlands/17-roof-trusses-and-weather-tight/004.jpg",
        "type": "image",
        "alt": "Roof Trusses and Weather-Tight, photo 5 of 26"
      },
      {
        "src": "/progress/southlands/17-roof-trusses-and-weather-tight/005.jpg",
        "type": "image",
        "alt": "Roof Trusses and Weather-Tight, photo 6 of 26"
      },
      {
        "src": "/progress/southlands/17-roof-trusses-and-weather-tight/006.jpg",
        "type": "image",
        "alt": "Roof Trusses and Weather-Tight, photo 7 of 26"
      },
      {
        "src": "/progress/southlands/17-roof-trusses-and-weather-tight/007.jpg",
        "type": "image",
        "alt": "Roof Trusses and Weather-Tight, photo 8 of 26"
      },
      {
        "src": "/progress/southlands/17-roof-trusses-and-weather-tight/008.jpg",
        "type": "image",
        "alt": "Roof Trusses and Weather-Tight, photo 9 of 26"
      },
      {
        "src": "/progress/southlands/17-roof-trusses-and-weather-tight/009.jpg",
        "type": "image",
        "alt": "Roof Trusses and Weather-Tight, photo 10 of 26"
      },
      {
        "src": "/progress/southlands/17-roof-trusses-and-weather-tight/010.jpg",
        "type": "image",
        "alt": "Roof Trusses and Weather-Tight, photo 11 of 26"
      },
      {
        "src": "/progress/southlands/17-roof-trusses-and-weather-tight/011.jpg",
        "type": "image",
        "alt": "Roof Trusses and Weather-Tight, photo 12 of 26"
      },
      {
        "src": "/progress/southlands/17-roof-trusses-and-weather-tight/012.jpg",
        "type": "image",
        "alt": "Roof Trusses and Weather-Tight, photo 13 of 26"
      },
      {
        "src": "/progress/southlands/17-roof-trusses-and-weather-tight/013.jpg",
        "type": "image",
        "alt": "Roof Trusses and Weather-Tight, photo 14 of 26"
      },
      {
        "src": "/progress/southlands/17-roof-trusses-and-weather-tight/014.jpg",
        "type": "image",
        "alt": "Roof Trusses and Weather-Tight, photo 15 of 26"
      },
      {
        "src": "/progress/southlands/17-roof-trusses-and-weather-tight/015.jpg",
        "type": "image",
        "alt": "Roof Trusses and Weather-Tight, photo 16 of 26"
      },
      {
        "src": "/progress/southlands/17-roof-trusses-and-weather-tight/016.jpg",
        "type": "image",
        "alt": "Roof Trusses and Weather-Tight, photo 17 of 26"
      },
      {
        "src": "/progress/southlands/17-roof-trusses-and-weather-tight/017.jpg",
        "type": "image",
        "alt": "Roof Trusses and Weather-Tight, photo 18 of 26"
      },
      {
        "src": "/progress/southlands/17-roof-trusses-and-weather-tight/018.jpg",
        "type": "image",
        "alt": "Roof Trusses and Weather-Tight, photo 19 of 26"
      },
      {
        "src": "/progress/southlands/17-roof-trusses-and-weather-tight/019.jpg",
        "type": "image",
        "alt": "Roof Trusses and Weather-Tight, photo 20 of 26"
      },
      {
        "src": "/progress/southlands/17-roof-trusses-and-weather-tight/020.jpg",
        "type": "image",
        "alt": "Roof Trusses and Weather-Tight, photo 21 of 26"
      },
      {
        "src": "/progress/southlands/17-roof-trusses-and-weather-tight/021.jpg",
        "type": "image",
        "alt": "Roof Trusses and Weather-Tight, photo 22 of 26"
      },
      {
        "src": "/progress/southlands/17-roof-trusses-and-weather-tight/022.jpg",
        "type": "image",
        "alt": "Roof Trusses and Weather-Tight, photo 23 of 26"
      },
      {
        "src": "/progress/southlands/17-roof-trusses-and-weather-tight/023.jpg",
        "type": "image",
        "alt": "Roof Trusses and Weather-Tight, photo 24 of 26"
      },
      {
        "src": "/progress/southlands/17-roof-trusses-and-weather-tight/024.jpg",
        "type": "image",
        "alt": "Roof Trusses and Weather-Tight, photo 25 of 26"
      },
      {
        "src": "/progress/southlands/17-roof-trusses-and-weather-tight/025.jpg",
        "type": "image",
        "alt": "Roof Trusses and Weather-Tight, photo 26 of 26"
      }
    ]
  },
  {
    "date": "April 2026",
    "title": "Roof Structure and Fit-Out",
    "items": [
      {
        "src": "/progress/southlands/16-roof-structure-and-fit-out/000.jpg",
        "type": "image",
        "alt": "Roof Structure and Fit-Out, photo 1 of 18"
      },
      {
        "src": "/progress/southlands/16-roof-structure-and-fit-out/001.jpg",
        "type": "image",
        "alt": "Roof Structure and Fit-Out, photo 2 of 18"
      },
      {
        "src": "/progress/southlands/16-roof-structure-and-fit-out/002.jpg",
        "type": "image",
        "alt": "Roof Structure and Fit-Out, photo 3 of 18"
      },
      {
        "src": "/progress/southlands/16-roof-structure-and-fit-out/003.jpg",
        "type": "image",
        "alt": "Roof Structure and Fit-Out, photo 4 of 18"
      },
      {
        "src": "/progress/southlands/16-roof-structure-and-fit-out/004.jpg",
        "type": "image",
        "alt": "Roof Structure and Fit-Out, photo 5 of 18"
      },
      {
        "src": "/progress/southlands/16-roof-structure-and-fit-out/005.jpg",
        "type": "image",
        "alt": "Roof Structure and Fit-Out, photo 6 of 18"
      },
      {
        "src": "/progress/southlands/16-roof-structure-and-fit-out/006.jpg",
        "type": "image",
        "alt": "Roof Structure and Fit-Out, photo 7 of 18"
      },
      {
        "src": "/progress/southlands/16-roof-structure-and-fit-out/007.jpg",
        "type": "image",
        "alt": "Roof Structure and Fit-Out, photo 8 of 18"
      },
      {
        "src": "/progress/southlands/16-roof-structure-and-fit-out/008.jpg",
        "type": "image",
        "alt": "Roof Structure and Fit-Out, photo 9 of 18"
      },
      {
        "src": "/progress/southlands/16-roof-structure-and-fit-out/009.jpg",
        "type": "image",
        "alt": "Roof Structure and Fit-Out, photo 10 of 18"
      },
      {
        "src": "/progress/southlands/16-roof-structure-and-fit-out/010.jpg",
        "type": "image",
        "alt": "Roof Structure and Fit-Out, photo 11 of 18"
      },
      {
        "src": "/progress/southlands/16-roof-structure-and-fit-out/011.jpg",
        "type": "image",
        "alt": "Roof Structure and Fit-Out, photo 12 of 18"
      },
      {
        "src": "/progress/southlands/16-roof-structure-and-fit-out/012.jpg",
        "type": "image",
        "alt": "Roof Structure and Fit-Out, photo 13 of 18"
      },
      {
        "src": "/progress/southlands/16-roof-structure-and-fit-out/013.jpg",
        "type": "image",
        "alt": "Roof Structure and Fit-Out, photo 14 of 18"
      },
      {
        "src": "/progress/southlands/16-roof-structure-and-fit-out/014.jpg",
        "type": "image",
        "alt": "Roof Structure and Fit-Out, photo 15 of 18"
      },
      {
        "src": "/progress/southlands/16-roof-structure-and-fit-out/015.jpg",
        "type": "image",
        "alt": "Roof Structure and Fit-Out, photo 16 of 18"
      },
      {
        "src": "/progress/southlands/16-roof-structure-and-fit-out/016.jpg",
        "type": "image",
        "alt": "Roof Structure and Fit-Out, photo 17 of 18"
      },
      {
        "src": "/progress/southlands/16-roof-structure-and-fit-out/017.jpg",
        "type": "image",
        "alt": "Roof Structure and Fit-Out, photo 18 of 18"
      }
    ]
  }
];
